
/**
 * Formate et normalise un numéro de téléphone
 * 
 * @param phone Le numéro de téléphone à formater
 * @returns Le numéro de téléphone formaté
 */
export function formatUserPhoneNumber(phone: string): string {
  if (!phone) return '';
  
  // Supprime les espaces et autres caractères non numériques sauf le + au début
  let formattedPhone = phone.trim();
  
  // Assurez-vous que le numéro commence par un "+" s'il ne commence pas déjà par un
  if (!formattedPhone.startsWith('+')) {
    // Si le numéro commence par un 0, on le remplace par +33 (France)
    if (formattedPhone.startsWith('0')) {
      formattedPhone = '+33' + formattedPhone.substring(1);
    } else {
      formattedPhone = '+' + formattedPhone;
    }
  }
  
  return formattedPhone;
}
